import Schedule from "./containers/Schedule";

export default function SchedulePage() {
  return <Schedule />;
}
